module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/2705b2deb589f82fc2f04f92c07a7831.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_assessments.svg
// module id = OHJl
// module chunks = 0